var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08751 3.0876C3.31532 2.8598 3.68466 2.8598 3.91247 3.0876L6.99999 6.17512L10.0875 3.0876C10.3153 2.8598 10.6847 2.8598 10.9125 3.0876C11.1403 3.31541 11.1403 3.68475 10.9125 3.91256L7.82495 7.00008L10.9125 10.0876C11.1403 10.3154 11.1403 10.6848 10.9125 10.9126C10.6847 11.1404 10.3153 11.1404 10.0875 10.9126L6.99999 7.82504L3.91247 10.9126C3.68466 11.1404 3.31532 11.1404 3.08751 10.9126C2.85971 10.6848 2.85971 10.3154 3.08751 10.0876L6.17503 7.00008L3.08751 3.91256C2.85971 3.68475 2.85971 3.31541 3.08751 3.0876Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b4a8488bf33a125dd8238898d0ddcdd0.svg";
export { ForwardRef as ReactComponent };